import { Reducer } from 'redux';
import * as actionTypes from './actionTypes';
import { IWorkflow, IWorkflowQueue } from '../business-objects/common';

interface IWorkflowState {
  workflows: IWorkflow[];
  keywords: any[];
  queues: IWorkflowQueue[];
}

const initialState = {
  workflows: [],
  keywords: [], //TODO: Be sure this is correct
  queues: [],
  driverHeldDaySetting: null,
};

const reducer: Reducer<IWorkflowState> = (state = initialState, action) => {
  //console.log('workflow action', action);
  switch (action.type) {
    case actionTypes.GET_WORKFLOWS: {
      //console.log('get all workflows', action.value);
      let _state = { ...state };
      action.value.workflows.forEach((workflow) =>
        workflow.workflowSteps.sort((a, b) =>
          a.stepNumber < b.stepNumber ? -1 : 1
        )
      );
      _state = { ...state, workflows: action.value.workflows };
      _state = { ..._state, queues: action.value.queues };
      return _state;
    }
    case actionTypes.LOAD_KEYWORDS_INTO_STORE: {
      let _state = {
        ...state,
        Keywords: action.value,
      };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
